import { Form, Radio } from "@/atoms"
import { TFunction } from "@/hooks/useTranslation"
import React from "react"
import { formatFieldName } from "../../helpers"
import { JiraFormItem } from "../../JiraFormItem"
import styles from "../../JiraIssueField.module.scss"
import { JiraFormItemProps } from "../../JiraIssueField.types"

export const SprintRadioGroup: React.FC<
  Omit<JiraFormItemProps, "children" | "fieldHint" | "formItemName"> & {
    fieldName: string
    formItemPrefix: string
    t: TFunction
    disabled?: boolean
  }
> = ({ fieldName, formItemPrefix, t, disabled, ...props }) => {
  const formattedFieldName = formatFieldName(fieldName)
  const fieldItemPrefix = [formItemPrefix, formattedFieldName]
  const formItemName = [...fieldItemPrefix, "value"]
  const form = Form.useFormInstance()
  const fieldHint = t("sprintField.hint")

  return (
    <div>
      <JiraFormItem
        fieldHint={fieldHint}
        formItemName={formItemName}
        {...props}
      >
        <Radio.Group
          disabled={disabled}
          className={styles.radioGroup}
          options={[
            { value: "current", label: t("sprintField.currentSprint") },
            { value: undefined, label: t("sprintField.noSprint") }
          ]}
          onChange={() =>
            form.resetFields([
              [...fieldItemPrefix, "key"],
              [...fieldItemPrefix, "type"]
            ])
          }
        />
      </JiraFormItem>
      <Form.Item
        name={[...fieldItemPrefix, "key"]}
        initialValue={props.fieldKey}
        hidden
      />
      <Form.Item
        name={[...fieldItemPrefix, "type"]}
        initialValue="sprint"
        hidden
      />
    </div>
  )
}
